import styled from '@emotion/styled';
import { Divider } from '@kc-console/common-ui';

interface BarDropGapDividerProps {
  hidden: boolean;
}

/**
 * 노출 목록(탑바)용 드롭 indicator — 항목 사이 in-flow 세로 Divider.
 */
export const FavoriteBarDropGapDivider = ({ hidden }: BarDropGapDividerProps) => (
  <StyledBarDivider
    flexItem
    thickness={2}
    component={'li'}
    orientation={'vertical'}
    variant={'middle'}
    margin={2}
    hidden={hidden}
  />
);

/**
 * 더보기 메뉴용 드롭 indicator — 항목 renderContent 내부 in-flow 가로 Divider.
 * @description
 * - PoC 디자인(디자인 리뷰 완료)과 동일한 모양.
 * - 항목 배열을 splice하지 않고 항목 내부에 in-flow로 렌더하므로
 *   DropdownMenu2의 index 기반 key가 유지되어 드래그 중 remount가 발생하지 않는다.
 */
export const FavoriteMenuDropGapDivider = () => (
  <StyledMenuDivider thickness={1} orientation={'horizontal'} variant={'middle'} margin={8} />
);

const StyledBarDivider = styled(Divider)`
  && {
    border-color: ${({ theme }) => theme.color['coolGray/300']};
  }
`;

const StyledMenuDivider = styled(Divider)`
  && {
    border-color: ${({ theme }) => theme.color['border/global/default']};
    pointer-events: none;
  }
`;
